import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { ReactElement } from 'react';

import { ROUTES } from '../../utils/routes';
import shopLogo from '../../../common/style/pool-alpin-logo-shop.svg';

const Anchor = styled(Link)(({ theme }) => ({
    padding: theme.spacing(1.25, 0),
    height: theme.spacing(6),

    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2.25, 2, 1),
        marginLeft: -16,
        height: theme.spacing(8),
    },
}));

export const PoolAlpinShopLogo = (): ReactElement => {
    return (
        <Anchor to={ROUTES.coverPage}>
            <Box sx={{ width: { sm: 150, xs: 103 }, height: { sm: 38, xs: 28 }, maxWidth: { sm: 150, xs: 103 } }}>
                <img src={shopLogo} alt="logo" style={{ width: '100%' }} />
            </Box>
        </Anchor>
    );
};
